module.exports = __webpack_public_path__ + "img/socialmedia_banner.dc6f084d.webp";